export default __webpack_public_path__ + "static/media/clock-green.27825064.svg";